import InventoryTransactionPage from "../../InventoryTransactionPage";

const InventoryTransferOut = () => <InventoryTransactionPage title="Transfer Out" step={6} description="Send inventory to another warehouse or branch." />;

export default InventoryTransferOut;
